const logotext = "I'm A Flower";
const hoverlogotext ="ㄴㅏㄴㅎㅗㅏ";
const meta = {
    title: "I'm A Flower",
  };

// const about = {
//     profile: "profile.jpg",
//     title: "I'm A Flower = 난화입니다.",
//     aboutme: "안녕하세요! 저는 김난화 'Dev_nhwa'입니다. 저의 좌우명은 '끝까지 하면 된다!'로 어떤일이든 끝까지 한다면 해결할 수 있다는 신념을 바탕으로 제가 가진 역량을 모두 보여줄 수 있는 FULL STACK 개발자를 꿈꾸고 있습니다."
    
// };
// const worktimeline = [{
//         jobtitle: "Designer of week",
//         where: "YAdfi",
//         date: "2020",
//     },
//     {
//         jobtitle: "Designer of week",
//         where: "Jamalya",
//         date: "2019",
//     },
//     {
//         jobtitle: "Designer of week",
//         where: "ALquds",
//         date: "2019",
//     },
// ];

// const skills = [{
//         name: "Python",
//         value: 90,
//     },
//     {
//         name: "Djano",
//         value: 85,
//     },
//     {
//         name: "Javascript",
//         value: 80,
//     },
//     {
//         name: "React",
//         value: 60,
//     },
//     {
//         name: "Jquery",
//         value: 85,
//     },
// ];

// const services = [{
//         title: "UI & UX Design",
//         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.",
//     },
//     {
//         title: "Mobile Apps",
//         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.",
//     },
//     {
//         title: "Wordpress Design",
//         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.",
//     },
// ];

const dataportfolio = [
{
    id: 1,
    icon: 'web',
    mockup: 'web',
    dir: 'springbootshop',
    name: 'Spring Boot Shop',
    work: 'Personal',
    project: 'Web Project',
    skills: "Spring, Spring Boot, JAVA, Thymeleaf",
    description: '스프링 부트와 JPA를 활용한 웹 애플리케이션 개발 프로젝트',
    link: 'https://devnhwa.notion.site/Spring-Boot-Shop-22ebd1b8ddf6440788bbd719486e9a41',
    main_img: {src: "springbootshop.png", alt: "springbootshop"},
    card_img: {src: "springbootshop_card.png", alt: "springbootshop"},
},
{
    id: 2,
    icon: 'web',
    mockup: 'web',
    dir: 'springcorebasics',
    name: 'Spring Core Basics',
    work: 'Personal',
    project: 'Web Project',
    skills: "Spring, Spring Boot, JAVA, Thymeleaf",
    description: '스프링 핵심 원리 학습 프로젝트',
    link: 'https://devnhwa.notion.site/Spring-Core-Basics-ea8f44057fcd4908bffe9afb8832dc3b',
    main_img: {src: "springcorebasics.png", alt: "springcorebasics"},
    card_img: {src: "springcorebasics_card.png", alt: "springcorebasics"},
},
{
    id: 3,
    icon: 'web',
    mockup: 'web',
    dir: 'startspringboot',
    name: 'Start Spring Boot',
    work: 'Personal',
    project: 'Web Project',
    skills: "Spring, Spring Boot, JAVA, Thymeleaf",
    description: '코드로 배우는 스프링 부트 학습 프로젝트',
    link: 'https://devnhwa.notion.site/Start-Spring-Boot-a760643d28034e27a6061f1cc1d8f667',
    main_img: {src: "startspringboot.png", alt: "startspringboot"},
    card_img: {src: "startspringboot_card.png", alt: "startspringboot"},
},
{   id: 4,
    icon: "design",
    mockup: 'book',
    dir: 'arablewhitepaper',
    name: "Arable Whitepaper",
    work: 'Team',
    project: "Design Project",
    skills: "Photoshop, Illustrator, Word",
    description: "Blockchain-based Arable Metaverse Platform Whitepaper Design",
    link: "https://devnhwa.notion.site/devnhwa-Business-Project-4265c2958c724c74949e5d2ac9cec7b3#695941fdfa27414888c0c9b7ac68a8bf",
    main_img: {src: "arablewhitepaper.png", alt: "arable whitepaper"},
    card_img: {src: "arablewhitepaper.png", alt: "arable whitepaper"},
},
{
    id: 5,
    icon: 'web',
    mockup: 'web',
    dir: 'arable',
    name: 'Arable Web Developement',
    work: 'Personal',
    project: 'Web Project',
    skills: "HTML5, CSS3, JS",
    description: 'Arable Web Developement',
    link: 'https://devnhwa.notion.site/devnhwa-Business-Project-4265c2958c724c74949e5d2ac9cec7b3#ddb869d83a5047a1af2e2a8fa7d73cdb',
    main_img: {src: "arable.png", alt: "arable"},
    card_img: {src: "arable_card.png", alt: "arable"},
},
{
    id: 6,
    icon: 'web',
    mockup: 'web',
    dir: 'diveflashweb',
    name: 'Diveflash Web Developement',
    work: 'Personal',
    project: 'Web Project',
    skills: "HTML5, CSS3, JS, React",
    description: '©Diveflash Web 구축',
    link: 'https://diveflash.com/',
    main_img: {src: "diveflashweb.png", alt: "diveflashweb"},
    card_img: {src: "diveflashweb_card.png", alt: "diveflashweb"},
},
{   id: 7,
    icon: "app",
    mockup: 'web',
    dir: 'diveflashfilter',
    name: "Diveflash Filter App",
    work: 'Team',
    project: "App Project",
    skills: "Flutter, Dart, C++, FireBase",
    description: "후보정 이미지 필터링 알고리즘 수중 사진 보정 앱 개발",
    link: "https://devnhwa.notion.site/devnhwa-Business-Project-4265c2958c724c74949e5d2ac9cec7b3#c9f327e97802475cacfb95af5b2c06bf",
    main_img: {src: "diveflashfilter.png", alt: "diveflashfilter"},
    card_img: {src: "diveflashfilter_card.png", alt: "diveflashfilter"},
},
{   id: 8,
    icon: "app",
    mockup: 'web',
    dir: 'diveflashsns',
    name: "Diveflash SNS App",
    work: 'Team',
    project: "App Project",
    skills: "Flutter, Dart",
    description: "Diveflash 다이버 전용 SNS 앱 개발",
    link: "https://xd.adobe.com/view/d738d4a1-e186-402d-8a08-80c27e63e38b-826b/grid",
    main_img: {src: "diveflashsns.png", alt: "diveflashsns"},
    card_img: {src: "diveflashsns_card.png", alt: "diveflashsns"},
},
{   id: 9,
    icon: "ai",
    mockup: 'web',
    dir: 'datavisualization',
    name: "Data Visualization Project",
    work: 'Personal',
    project: "AI Project",
    skills: "Python - pandas, numpy, matplotlib 패키지",
    description: "한국, 중국관광객 csv 데이터를 활용한 제주 관광산업 카드 이용 현황 분석 Project",
    link: "https://devnhwa.notion.site/Project-7d7f5e20abca43d8a9b7be77e8af470b",
    main_img: {src: "datavisualization.png", alt: "datavisualization"},
    card_img: {src: "datavisualization_card.png", alt: "datavisualization"},
},
{   id: 10,
    icon: "web",
    mockup: 'list',
    dir: 'paullab',
    name: "Interactive Web Publishing",
    work: 'Personal',
    project: "Web Project",
    skills: "HTML5, CSS, JavasCript",
    description: "바울랩ICT Interactive Web Publishing Project",
    link: '',
    main_img: [{src: "paullab1.png", alt: "paullab1", link: "https://paullab.co.kr/referenceroom.html"},{src: "paullab2.png", alt: "paullab2",link:"https://paullab.co.kr/halloffame.html"}],
    card_img: {src: "paullab_card.png", alt: "paullab"},
},
{   id: 11,
    icon: "web",
    mockup: 'web',
    dir: 'daumsearch',
    name: "Daum 1boon 서비스 클론 코딩",
    work: 'Personal',
    project: "Web Project",
    skills: "HTML5, CSS3, JS(ES6)",
    description: "fetch API를 통해 kakao 1boon에서 가져온 데이터를 활용하여 1boon 서비스 구축",
    link: "https://devnhwa.notion.site/Daum-1boon-7cf8e01deace48eeab7765a5b23cf456",
    main_img: {src: "daumsearch.png", alt: "daumsearch"},
    card_img: {src: "daumsearch_card.png", alt: "daumsearch"},
},
{   id: 12,
    icon: "web",
    mockup: 'web',
    dir: 'startfe',
    name: "START-FE",
    work: 'Personal',
    project: "Web Project",
    skills: "HTML5, CSS3, JS, JS(ES6), React",
    description: "매 주차 학습하는 Front-end 프로젝트",
    link: "https://devnhwa.notion.site/START-FE-d9b9f2a488454386bdd33b4e51288871",
    main_img: {src: "startfe.png", alt: "start-fe"},
    card_img: {src: "startfe_card.png", alt: "start-fe"},
},
{   id: 13,
    icon: "app",
    mockup: 'app',
    dir: 'myday',
    name: "Myday : 오늘을 기록하다",
    work: 'Team',
    project: "Web Project",
    skills: "Android Studio , JAVA , Firebase",
    description: "매일을 기록하는 일기장 App 프로젝트",
    link: "https://devnhwa.notion.site/Myday-9bfdac0607f7467893b6cfb7d0450f59",
    main_img: {src: "myday.png", alt: "myday"},
    card_img: {src: "myday.png", alt: "myday"},
},
{   id: 14,
    icon: "design",
    mockup: 'app',
    dir: 'daybylist',
    name: "Day By List",
    work: 'Personal',
    project: "UI/UX Design",
    skills: "Adobe XD, Photoshop, Illustrator",
    description: "To-Do List 관리 앱 UX/UI 설계",
    link: "https://github.com/nhwa/daybylist-xd-ui-ux",
    main_img: {src: "daybylist.png", alt: "daybylist"},
    card_img: {src: "daybylist.png", alt: "daybylist"},
},
{   id: 15,
    icon: "ai",
    mockup: 'web',
    dir: 'predictionprices',
    name: "Prediction Prices AI Project",
    work: 'Personal',
    project: "AI Project",
    skills: "Python - pandas, numpy, matplotlib 패키지",
    description: "지역별 서비스가격을 통한 물가 예측 AI Project",
    link: "https://devnhwa.notion.site/AI-Project-2a59e2c54b8240cba20e3954721db1cc",
    main_img: {src: "predictionprices.png", alt: "predictionprices"},
    card_img: {src: "predictionprices_card.png", alt: "predictionprices"},
},
{
    id: 16,
    icon: "app",
    mockup: 'app',
    dir: 'menuselection',
    name: '밥뭐먹잰 By 제주대',
    work: 'Personal',
    project: 'App Project',
    skills: 'Android Studio, Java',
    description: '제주대학교 근처 식당의 메뉴를 바탕으로 메뉴를 정해주고 근처 식당의 정보를 알 수 있는 앱 개발 ',
    link: 'https://devnhwa.notion.site/By-2cf00d621eeb49a1b2ed4920428e8615',
    main_img: {src: "menuselection.png", alt: "밥뭐먹잰"},
    card_img: {src: "menuselection.png", alt: "밥뭐먹잰"},
},
{   id: 16,
    icon: "app",
    mockup: 'app',
    dir: 'moberz',
    name: "MOBERZ",
    work: 'Team',
    project: "App Project",
    skills: "Android Studio , JAVA",
    description: "축제 정보 공유 App 개발",
    link: "https://devnhwa.notion.site/MOBERZ-16815e4776b54995b6d00cc886764f9a",
    main_img: {src: "moberz.png", alt: "Moberz"},
    card_img: {src: "moberz.png", alt: "Moberz"},
},
{   id: 17,
    icon: "app",
    mockup: 'app',
    dir: 'jnubus',
    name: "JNU BUS",
    work: 'Team',
    project: "App Project",
    skills: "Android Studio , JAVA",
    description: "제주대학교 교내 셔틀버스 안내 App Project",
    link: "https://devnhwa.notion.site/JNUBUS-7e99d81a563a4c059d118881b4ad8805",
    main_img: {src: "jnubus.png", alt: "jnubus"},
    card_img: {src: "jnubus.png", alt: "jnubus"},
},
{   id: 18,
    icon: "web",
    mockup: 'web',
    dir: 'beforeportfolio',
    name: "Before Portfolio",
    work: 'Personal',
    project: "Web Project",
    skills: "HTML5, CSS3, JS",
    description: "성장을 위한 발판",
    link: "https://nhwa.github.io/beforeportfolio_html_frontend/main.html",
    main_img: {src: "beforeportfolio.png", alt: "beforeportfolio"},
    card_img: {src: "beforeportfolio_card.png", alt: "beforeportfolio"},
},
{   id: 19,
    icon: "web",
    mockup: 'app',
    dir: 'jejufreewifi',
    name: "JEJU FREE Wi-Fi Publishing Project",
    work: 'Personal',
    project: "Web Project",
    skills: "HTML5, CSS, JavasCript",
    description: "제주 공공 Wi-Fi 통합 관제 시스템 구축 Project",
    link: "https://devnhwa.notion.site/devnhwa-Business-Project-4265c2958c724c74949e5d2ac9cec7b3#be1b8ad41727479cb49666b17782507d",
    main_img: {src: "jejufreewifi.png", alt: "jejufreewifi"},
    card_img: {src: "jejufreewifi.png", alt: "jejufreewifi"},
},
{   id: 20,
    icon: "design",
    mockup: 'web',
    dir: 'badoongbadoong',
    name: "JEJU FREE Wi-Fi Publishing Project",
    work: 'Personal',
    project: "Web Project",
    skills: "Unity, C#",
    description: "해녀 캐릭터를 활용한 횡스크롤 방식의 장애물 피하기 게임 개발 프로젝트",
    link: "https://devnhwa.notion.site/5cbfc7557bf2403cadeae78934f56f55",
    main_img: {src: "badoongbadoong.png", alt: "jejufreewifi"},
    card_img: {src: "badoongbadoong_card.png", alt: "jejufreewifi"},
},

{   id: 21,
    icon: "web",
    mockup: 'web',
    dir: 'silvermedal',
    name: "Silver Medal",
    work: 'Personal',
    project: "Contest",
    skills: "Photoshop, HTML5, CSS, JavasCript, PHP, Apache, Mysql",
    description: "제주도 지방기능경기대회 은메달 수상",
    link: "http://www.jejumaeil.net/news/articleView.html?idxno=178584",
    main_img: {src: "silvermedal.png", alt: "silvermedal"},
    card_img: {src: "silvermedal_card.png", alt: "silvermedal"},
},
{   
    id: 22,
    icon: "web",
    mockup: 'web',
    dir: 'spark',
    name: "Spark Design Awards",
    work: 'Team',
    project: "UI/UX Design",
    description: "Concept 2018 FINALLIST",
    skills: "Photoshop, Illustrator, Rhino",
    link: "docs/spark.pdf",
    main_img: {src: "spark.jpg", alt: "spark design awards"},
    card_img: {src: "spark_card.jpg", alt: "spark design awards"},
},
{   id: 23,
    icon: "web",
    mockup: 'web',
    dir: 'dreamers',
    name: "Dreamers",
    work: 'Team',
    project: "Web Project",
    skills: "PHP, Apache, MariaDB, Tomcat, HTML5, CSS3, JS",
    description: "버킷리스트를 공유하고 회원들이 서로에게 미션을 제시하는 커뮤니티 웹 개발 프로젝트",
    link: "https://devnhwa.notion.site/Dreamers-4b8d2725ed794d86bfd898068f058e16",
    main_img: {src: "dreamers.png", alt: "dreamers"},
    card_img: {src: "dreamers.png", alt: "dreamers"},
},
{   id: 24,
    icon: "web",
    mockup: 'book',
    dir: 'kipee',
    name: "2017 학술발표대회 논문집 수록",
    work: 'Team',
    project: "Web Project",
    skills: "HTML5, CSS3, JS",
    description: "자기 주도 학습 의욕향상 시뮬레이션, 자기주도형 학습 매체 개발 총 두건 수록",
    link: "docs/kipee.pdf",
    main_img: {src: "kipee.jpg", alt: "kipee"},
    card_img: {src: "kipee.jpg", alt: "kipee"},
},
];

const contactConfig = {
    YOUR_EMAIL: "devnhwa@gmail.com",
    YOUR_FONE: "+82 10 - 5015 - 4038",
    description: "언제든지 연락주세요 :) ",
    YOUR_SERVICE_ID: "service_f03osod",
    YOUR_TEMPLATE_ID: "template_59eg0xd",
    YOUR_USER_ID: "07BHjcjXXPnCqPtM0",
};

const socialprofils = {
    github: "https://github.com/nhwa",
    youtube: "https://www.youtube.com/channel/UCbr3j7VSvgNMnwpTII45vag",
    notion: "https://devnhwa.notion.site/I-m-A-Flower-a137ceae4d454de2a75b7650971ecb5f"
};
export {
    meta,
    logotext,
    hoverlogotext,
    socialprofils,
    dataportfolio,
    contactConfig,
};
